import React from "react";
import { apiRequest } from "./api/requestHelper";
import config from "../src/config/app.json";
import SectionPage from "../pages/[id]";
import Modal from "react-modal";
import { useRouter } from "next/router";
import Preview from "../src/components/Preview";
import useFetchData from "../src/hooks/useFecthData";

Modal.setAppElement("#__next");

const apiUrl = config["APIURIS"][config["APIURIS"]["current"]];

function Search({ data, tag, currentQuery, toShowMessage }) {
  const router = useRouter();
  const { modalData } = useFetchData();

  function getCloseLink() {
    return router.query.continuation
      ? `${router.pathname}/?id=${router.query.id}&continuation=${router.query.continuation}`
      : `${router.pathname}/?id=${router.query.id}`;
  }
  return (
    <>
      <SectionPage
        data={data}
        tag={tag}
        isSearchPage={true}
        currentQuery={currentQuery}
        toShowMessage={toShowMessage}
      />
      <Modal
        isOpen={!!router.query.templateId}
        onRequestClose={() =>
          router.push(getCloseLink(), undefined, { shallow: true })
        }
        className="modal"
        overlayClassName="overlay"
      >
        <Preview data={modalData} allData={data} closeLink={getCloseLink()} />
      </Modal>
    </>
  );
}

export default React.memo(Search);

export async function getServerSideProps({ query }) {
  const fetchQuery = () => {
    return {
      method: "post",
      url: `${apiUrl}dynamic/search/`,
      options: {
        query: query.id,
        from: query.continuation || 0,
        size: 30,
      },
    };
  };

  const { data } = await apiRequest(
    fetchQuery().method,
    fetchQuery().url,
    fetchQuery().options
  );

  if (!data["data"]) {
    return { props: { errorCode: 500 } };
  }

  if (!!data["data"] && !data["data"]["all_templates"]) {
    if (
      Object.keys(data["data"]).length <= 0 ||
      data["data"].seo_data.length <= 0 ||
      Object.keys(data["data"].templates).length <= 0
    ) {
      return {
        notFound: true,
      };
    }
  }

  const tempData = {
    seo_data: data["data"]["seo_data"],
    templates:
      Object.keys(data["data"]["templates"]).length > 0
        ? data["data"]["templates"]
        : data["data"]["all_templates"],
    trackId: data["data"]["trackid"],
  };
  const toShowMessage = data["data"]["all_templates"] ? true : false;
  return {
    props: {
      data: tempData,
      tag: "",
      currentQuery: query.id,
      toShowMessage,
    },
  };
}
